"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _globalComponentsLibrary = require("global-components-library");
var _reactstrap = require("reactstrap");
var _helpers = require("../../utils/helpers");
require("./LinksModal.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var LinksModal = function LinksModal(_ref) {
  var isOpen = _ref.isOpen,
    setOpen = _ref.setOpen,
    onInsert = _ref.onInsert,
    inittext = _ref.inittext,
    initurl = _ref.initurl;
  var _useTranslation = (0, _reactI18next.useTranslation)(['links-modal']),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    text = _useState2[0],
    setText = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    url = _useState4[0],
    setURL = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    textError = _useState6[0],
    setTextError = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    urlError = _useState8[0],
    setURLError = _useState8[1];
  (0, _react.useEffect)(function () {
    setTextError(false);
    setURLError(false);
  }, [text, url]);
  (0, _react.useEffect)(function () {
    if (inittext) setText(inittext);
  }, [inittext]);
  (0, _react.useEffect)(function () {
    if (initurl) setURL(initurl);
  }, [initurl]);
  (0, _react.useEffect)(function () {
    if (!isOpen) {
      setText('');
      setURL('');
    }
  }, [isOpen]);
  var onInsertBtn = function onInsertBtn() {
    if (text !== '' && url !== '' && (0, _helpers.isValidURL)(url)) {
      onInsert({
        text: text,
        url: url
      });
      setOpen(false);
    }
    setTextError(text === '');
    setURLError(url === '' || !(0, _helpers.isValidURL)(url));
  };
  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Modal, {
    className: "uin-links",
    isOpen: isOpen,
    toggle: function toggle() {
      return setOpen(!isOpen);
    },
    centered: true
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalHeader, {
    toggle: function toggle() {
      return setOpen(!isOpen);
    }
  }, " ", t('title')), /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalBody, null, /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.LabelInput, {
    value: text,
    label: t('label-text'),
    focus: true,
    error: textError,
    errorMessage: t('text-error'),
    placeholder: t('label-text'),
    onChange: setText
  }), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.LabelInput, {
    value: url,
    label: t('label-url'),
    focus: true,
    error: urlError,
    errorMessage: t('url-error'),
    placeholder: t('label-url'),
    onChange: setURL
  })), /*#__PURE__*/_react["default"].createElement(_reactstrap.ModalFooter, null, /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
    color: "primary",
    onClick: onInsertBtn,
    disabled: text === '' || url === ''
  }, t('insert'))));
};
LinksModal.propTypes = {
  isOpen: _propTypes["default"].bool.isRequired,
  setOpen: _propTypes["default"].func.isRequired,
  onInsert: _propTypes["default"].func.isRequired,
  inittext: _propTypes["default"].string,
  initurl: _propTypes["default"].string
};
var _default = exports["default"] = LinksModal;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/LinksModal/LinksModal.js
// module id = 1412
// module chunks = 0